import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Route, Routes } from 'react-router-dom';
import { Login, Settings, Tokens, } from '../pages';
import { ProtectedRoute } from './ProtectedRoute';
import { ActiveTabProvider } from '../contexts/ActiveTabContext';
export var AppRouter = function () {
    return (_jsx(ActiveTabProvider, { children: _jsxs(Routes, { children: [_jsx(Route, { path: '/login', element: _jsx(Login, {}) }), _jsx(Route, { path: '/', element: _jsxs(ProtectedRoute, { children: [" ", _jsx(Tokens, {}), " "] }) }), _jsx(Route, { path: '/settings', element: _jsxs(ProtectedRoute, { children: [" ", _jsx(Settings, {}), " "] }) })] }) }));
};
